import general from "./imgs/general.png";
const PortfolioImg: string[] = [general];

export default PortfolioImg;
